import { Model } from './model';
import { File } from './file';
import { Incarico } from './incarico';
export class Tavola extends Model {
  static apiUrl: string = "tavole";

  nome: string;
  descrizione: string;
  files: File[];
  foto_disponibili: File[];
  incarico: Incarico;
  deserialize(input: any): Tavola {
    let retV: Tavola = new Tavola();

    retV = super.deserialize(input) as Tavola;

    if (input?.files) {
      retV.files = input.files.map(m => new File().deserialize(m));
    }
    if (input?.foto_disponibili) {
      retV.foto_disponibili = input.foto_disponibili.map(m => new File().deserialize(m));
    }

    if (input?.incarico) {
      retV.incarico = new Incarico().deserialize(input?.incarico);
    }
    return retV;
  }

}
